import festiveIcon from '../assets/img/party.svg';
import familyFriendlyIcon from '../assets/img/family.svg';
import educationalIcon from '../assets/img/educational.svg';
import kidsIcon from '../assets/img/kids.svg';
import businessIcon from '../assets/img/business.svg';
import festivalIcon from '../assets/img/festival.svg';
import entertainmentIcon from '../assets/img/entertainment.svg';
import freeIcon from '../assets/img/free.svg';
import CreateIcon from '@material-ui/icons/Create';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { AddCircle, RemoveCircle } from '@material-ui/icons';
import VisibilityIcon from '@mui/icons-material/Visibility';

export const SELECT_ICON = [
  { id: 'activityCalendarSelectIcon01', url: festiveIcon, name: 'Festive' },
  {
    id: 'activityCalendarSelectIcon02',
    url: familyFriendlyIcon,
    name: 'Family Friendly',
  },
  {
    id: 'activityCalendarSelectIcon03',
    url: educationalIcon,
    name: 'Educational',
  },
  { id: 'activityCalendarSelectIcon04', url: kidsIcon, name: 'Kids' },
  { id: 'activityCalendarSelectIcon05', url: businessIcon, name: 'Business' },
  {
    id: 'activityCalendarSelectIcon06',
    url: festivalIcon,
    name: 'Promotional',
  },
  {
    id: 'activityCalendarSelectIcon07',
    url: entertainmentIcon,
    name: 'Entertainment',
  },
  { id: 'activityCalendarSelectIcon08', url: freeIcon, name: 'Free' },
];

export const CREATE_ACTIVITY = 'create activity';

export const CREATE_ACTIVITY_TAB = [
  { id: 0, name: 'Details', isValid: false },
  { id: 1, name: 'Location', isValid: false },
  { id: 2, name: 'Schedule', isValid: true },
  { id: 3, name: 'Waiver', isValid: true },
  { id: 4, name: 'Information', isValid: true },
  { id: 5, name: 'CTA', isValid: true },
  { id: 6, name: 'Banner', isValid: true },
  { id: 7, name: 'Media', isValid: true },
];

export const ACTIVITY_CALENDAR_CARD_TABS = [
  'Details',
  'Location',
  'Schedule',
  'Waiver',
  'Information',
  'CTA',
  'Banner',
  'Media',
];

export const ACTIVITY_CALENDAR_INFO_TYPES = [
  {
    text: 'Email',
    value: 'EMAIL',
    title: 'Add Email Title',
    valueType: 'Email',
  },
  {
    text: 'URL',
    value: 'URL',
    title: 'Add URL Title',
    valueType: 'URL',
  },
  {
    text: 'Phone Number',
    value: 'PHONE',
    title: 'Add Phone Number Title',
    valueType: 'Phone',
  },
];

export const ACTIVITY_CALENDAR = 'activity calendar';
export const ACTIVITY_CALENDAR_TYPE_CATEGORY = 'CATEGORY';
export const ACTIVITY_CALENDAR_CATEGORY_VIEW = 'category_view';
export const ACTIVITY_CALENDAR_TYPE_ACTIVITIES = 'Activities';
export const ACTIVITY_CALENDAR_CATEGORY_CREATE = 'category_create';
export const ACTIVITY_CALENDAR_CATEGORY_EDIT = 'category_edit';
export const ACTIVITY_CALENDAR_CREATE = 'activity_calendar_create';
export const ACTIVITY_CALENDAR_EDIT = 'activity_calendar_edit';
export const ACTIVITY_CALENDAR_IMAGE_TYPE = 'activity_calendar';
export const ACTIVITY_CATEGORY_TAB_LIST = ['Details', 'Media'];
export const FILTER_TYPE_TAG = 'tag';
export const FILTER_TYPE_STATUS = 'status';
export const FILTER_TYPE_AVAILABILITY = 'availability';
export const FILTER_TYPE_LOCATION = 'location';
export const FILTER_TYPE_PRICE = 'price';
export const FILTER_TYPE_CATEGORY = 'category';
export const AVAILABILITY_RESIDENTS_ONLY = 'residentsOnly';
export const AVAILABILITY_OPEN_TO_ALL = 'opentoall';
export const TAB_LABEL_DETAILS = 'Details';
export const TAB_LABEL_MEDIA = 'Media';

export const CANNOT_SELECT_PAST_TIME_START_TIME =
  'The selected start time cannot be earlier than the current time. Please choose a valid start time';

export const CANNOT_SELECT_FUTURE_TIME =
  'The selected start time cannot be later than the end time. Please adjust your time selection to ensure a valid time range ';

export const CANNOT_SELECT_PAST_TIME_END_TIME =
  'The selected end time cannot be earlier than the current time. Please choose a valid end time';

export const CANNOT_SELECT_END_TIME_PAST_START_TIME =
  'The selected end time cannot be earlier than the start time. Please adjust your time selection to ensure a valid time range.';

export const CANNOT_SELECT_FUTURE_DATE =
  'The selected start date cannot be later than the end date. Please adjust your date selection to ensure a valid date range.';

export const CANNOT_SELECT_END_DATE_PAST_START_DATE =
  'The selected end date cannot be earlier than the start date. Please adjust your date selection to ensure a valid date range.';

export const CAN_SELECT_DATE_NUMBER_UNIQUE = 'Date should be a unique number.';

export const ACTIVITY_FILTER_LIST = [
  { id: '2', name: 'Category', isSubCategory: true },
  { id: '3', name: 'Status', isSubCategory: true },
  { id: '4', name: 'Location', isSubCategory: true },
  { id: '5', name: 'Availability', isSubCategory: true },
  { id: '6', name: 'Price', isSubCategory: true },
  { id: '7', name: 'Tags', isSubCategory: true },
];

export const STATUS_SUB_CATEGORY_LIST = [
  { id: 'statusSubCategoryList1', name: 'Active', label: 'ACTIVATED' },
  { id: 'statusSubCategoryList2', name: 'Inactive', label: 'DEACTIVATED' },
];

export const STATUS_MAPPING = {
  ACTIVATED: true,
  DEACTIVATED: false,
};

export const CALENDAR_VIEW = [
  { name: 'Day View', id: 'day' },
  { name: 'Week View', id: 'week' },
  { name: 'Month View', id: 'month' },
];

export const ACTIVITY_CALENDAR_ACTIONS = [
  {
    id: 'action01',
    name: 'Edit',
    icon: <CreateIcon className='me-2 action-menu-icon' />,
  },
  {
    id: 'action02',
    name: 'View',
    icon: <VisibilityIcon className='me-2 action-menu-icon' />,
  },
  {
    id: 'action03',
    name: 'Deactivate',
    getIcon: (isActive) =>
      isActive ? (
        <RemoveCircle className='me-2 action-menu-icon' />
      ) : (
        <AddCircle className='me-2 action-menu-icon' />
      ),
  },
  {
    id: 'action04',
    name: 'Delete',
    icon: <DeleteForeverIcon className='me-2 action-menu-icon' />,
  },
];

export const DAY = 'DAY';

export const ACTIVATED_STATUS = 'ACTIVATED';

export const ALWAYS_ACTIVE = 'alwaysActive';

export const SCHEDULE_TYPES = ['ONE_TIME', 'RECURRING', 'MONTH', 'ALWAYS_ACTIVE'];

export const ACTIVITY_TYPES = ['oneTime', 'recurring', 'alwaysActive'];

export const DATE_TIME_TYPES = ['startTime', 'endTime', 'startDate', 'endDate'];

export const AVAILABILITY_SUB_CATEGORY_LIST = [
  {
    id: 'residentsOnly',
    name: 'Residents Only',
    label: 'Residents Only',
    isChecked: false,
  },
  {
    id: 'opentoall',
    name: 'Open to All',
    label: 'Open to All',
    isChecked: false,
  },
];

export const LOCATION_SUB_CATEGORY_LIST = [
  {
    id: 'HOTEL',
    name: 'Hotel',
    label: 'Hotel',
    isChecked: false,
  },
  {
    id: 'EXTERNAL',
    name: 'External',
    label: 'External',
    isChecked: false,
  },
  {
    id: 'URL',
    name: 'Online',
    label: 'Online',
    isChecked: false,
  },
];

export const PRICE_SUB_CATEGORY_LIST = [
  {
    id: 'free',
    name: 'Free',
    label: 'Free',
    isChecked: false,
  },
  {
    id: 'paid',
    name: 'Paid',
    label: 'Paid',
    isChecked: false,
  },
];

export const SLOT_DURATION_OPTIONS = [
  { id: '15', name: '15 minutes' },
  { id: '30', name: '30 minutes' },
  { id: '45', name: '45 minutes' },
  { id: '60', name: '1 hour' },
  { id: '75', name: '1 hour 15 minutes' },
  { id: '90', name: '1 hour 30 minutes' },
  { id: '105', name: '1 hour 45 minutes' },
  { id: '120', name: '2 hours' },
  { id: '135', name: '2 hours 15 minutes' },
  { id: '150', name: '2 hours 30 minutes' },
  { id: '165', name: '2 hours 45 minutes' },
  { id: '180', name: '3 hours' },
  { id: '195', name: '3 hours 15 minutes' },
  { id: '210', name: '3 hours 30 minutes' },
  { id: '225', name: '3 hours 45 minutes' },
  { id: '240', name: '4 hours' },
  { id: '255', name: '4 hours 15 minutes' },
  { id: '270', name: '4 hours 30 minutes' },
  { id: '285', name: '4 hours 45 minutes' },
  { id: '300', name: '5 hours' },
  { id: '315', name: '5 hours 15 minutes' },
  { id: '330', name: '5 hours 30 minutes' },
  { id: '345', name: '5 hours 45 minutes' },
  { id: '360', name: '6 hours' },
  { id: '375', name: '6 hours 15 minutes' },
  { id: '390', name: '6 hours 30 minutes' },
  { id: '405', name: '6 hours 45 minutes' },
  { id: '420', name: '7 hours' },
  { id: '435', name: '7 hours 15 minutes' },
  { id: '450', name: '7 hours 30 minutes' },
  { id: '465', name: '7 hours 45 minutes' },
  { id: '480', name: '8 hours' },
  { id: '495', name: '8 hours 15 minutes' },
  { id: '510', name: '8 hours 30 minutes' },
  { id: '525', name: '8 hours 45 minutes' },
  { id: '540', name: '9 hours' },
  { id: '555', name: '9 hours 15 minutes' },
  { id: '570', name: '9 hours 30 minutes' },
  { id: '585', name: '9 hours 45 minutes' },
  { id: '600', name: '10 hours' },
  { id: '615', name: '10 hours 15 minutes' },
  { id: '630', name: '10 hours 30 minutes' },
  { id: '645', name: '10 hours 45 minutes' },
  { id: '660', name: '11 hours' },
  { id: '675', name: '11 hours 15 minutes' },
  { id: '690', name: '11 hours 30 minutes' },
  { id: '705', name: '11 hours 45 minutes' },
  { id: '720', name: '12 hours' },
  { id: '735', name: '12 hours 15 minutes' },
  { id: '750', name: '12 hours 30 minutes' },
  { id: '765', name: '12 hours 45 minutes' },
  { id: '780', name: '13 hours' },
  { id: '795', name: '13 hours 15 minutes' },
  { id: '810', name: '13 hours 30 minutes' },
  { id: '825', name: '13 hours 45 minutes' },
  { id: '840', name: '14 hours' },
  { id: '855', name: '14 hours 15 minutes' },
  { id: '870', name: '14 hours 30 minutes' },
  { id: '885', name: '14 hours 45 minutes' },
  { id: '900', name: '15 hours' },
  { id: '915', name: '15 hours 15 minutes' },
  { id: '930', name: '15 hours 30 minutes' },
  { id: '945', name: '15 hours 45 minutes' },
  { id: '960', name: '16 hours' },
  { id: '975', name: '16 hours 15 minutes' },
  { id: '990', name: '16 hours 30 minutes' },
  { id: '1005', name: '16 hours 45 minutes' },
  { id: '1020', name: '17 hours' },
  { id: '1035', name: '17 hours 15 minutes' },
  { id: '1050', name: '17 hours 30 minutes' },
  { id: '1065', name: '17 hours 45 minutes' },
  { id: '1080', name: '18 hours' },
  { id: '1095', name: '18 hours 15 minutes' },
  { id: '1110', name: '18 hours 30 minutes' },
  { id: '1125', name: '18 hours 45 minutes' },
  { id: '1140', name: '19 hours' },
  { id: '1155', name: '19 hours 15 minutes' },
  { id: '1170', name: '19 hours 30 minutes' },
  { id: '1185', name: '19 hours 45 minutes' },
  { id: '1200', name: '20 hours' },
  { id: '1215', name: '20 hours 15 minutes' },
  { id: '1230', name: '20 hours 30 minutes' },
  { id: '1245', name: '20 hours 45 minutes' },
  { id: '1260', name: '21 hours' },
  { id: '1275', name: '21 hours 15 minutes' },
  { id: '1290', name: '21 hours 30 minutes' },
  { id: '1305', name: '21 hours 45 minutes' },
  { id: '1320', name: '22 hours' },
  { id: '1335', name: '22 hours 15 minutes' },
  { id: '1350', name: '22 hours 30 minutes' },
  { id: '1365', name: '22 hours 45 minutes' },
  { id: '1380', name: '23 hours' },
  { id: '1395', name: '23 hours 15 minutes' },
  { id: '1410', name: '23 hours 30 minutes' },
  { id: '1425', name: '23 hours 45 minutes' },
  { id: '1440', name: '24 hours' },
];

export const PADDING_DURATION_OPTIONS = [
  { id: '0', name: '0 minutes' },
  { id: '15', name: '15 minutes' },
  { id: '30', name: '30 minutes' },
  { id: '45', name: '45 minutes' },
  { id: '60', name: '1 hour' },
  { id: '75', name: '1 hour 15 minutes' },
  { id: '90', name: '1 hour 30 minutes' },
  { id: '105', name: '1 hour 45 minutes' },
  { id: '120', name: '2 hours' },
  { id: '135', name: '2 hours 15 minutes' },
  { id: '150', name: '2 hours 30 minutes' },
  { id: '165', name: '2 hours 45 minutes' },
  { id: '180', name: '3 hours' },
  { id: '195', name: '3 hours 15 minutes' },
  { id: '210', name: '3 hours 30 minutes' },
  { id: '225', name: '3 hours 45 minutes' },
  { id: '240', name: '4 hours' },
  { id: '255', name: '4 hours 15 minutes' },
  { id: '270', name: '4 hours 30 minutes' },
  { id: '285', name: '4 hours 45 minutes' },
  { id: '300', name: '5 hours' },
  { id: '315', name: '5 hours 15 minutes' },
  { id: '330', name: '5 hours 30 minutes' },
  { id: '345', name: '5 hours 45 minutes' },
  { id: '360', name: '6 hours' },
  { id: '375', name: '6 hours 15 minutes' },
  { id: '390', name: '6 hours 30 minutes' },
  { id: '405', name: '6 hours 45 minutes' },
  { id: '420', name: '7 hours' },
  { id: '435', name: '7 hours 15 minutes' },
  { id: '450', name: '7 hours 30 minutes' },
  { id: '465', name: '7 hours 45 minutes' },
  { id: '480', name: '8 hours' },
  { id: '495', name: '8 hours 15 minutes' },
  { id: '510', name: '8 hours 30 minutes' },
  { id: '525', name: '8 hours 45 minutes' },
  { id: '540', name: '9 hours' },
  { id: '555', name: '9 hours 15 minutes' },
  { id: '570', name: '9 hours 30 minutes' },
  { id: '585', name: '9 hours 45 minutes' },
  { id: '600', name: '10 hours' },
  { id: '615', name: '10 hours 15 minutes' },
  { id: '630', name: '10 hours 30 minutes' },
  { id: '645', name: '10 hours 45 minutes' },
  { id: '660', name: '11 hours' },
  { id: '675', name: '11 hours 15 minutes' },
  { id: '690', name: '11 hours 30 minutes' },
  { id: '705', name: '11 hours 45 minutes' },
  { id: '720', name: '12 hours' },
  { id: '735', name: '12 hours 15 minutes' },
  { id: '750', name: '12 hours 30 minutes' },
  { id: '765', name: '12 hours 45 minutes' },
  { id: '780', name: '13 hours' },
  { id: '795', name: '13 hours 15 minutes' },
  { id: '810', name: '13 hours 30 minutes' },
  { id: '825', name: '13 hours 45 minutes' },
  { id: '840', name: '14 hours' },
  { id: '855', name: '14 hours 15 minutes' },
  { id: '870', name: '14 hours 30 minutes' },
  { id: '885', name: '14 hours 45 minutes' },
  { id: '900', name: '15 hours' },
  { id: '915', name: '15 hours 15 minutes' },
  { id: '930', name: '15 hours 30 minutes' },
  { id: '945', name: '15 hours 45 minutes' },
  { id: '960', name: '16 hours' },
  { id: '975', name: '16 hours 15 minutes' },
  { id: '990', name: '16 hours 30 minutes' },
  { id: '1005', name: '16 hours 45 minutes' },
  { id: '1020', name: '17 hours' },
  { id: '1035', name: '17 hours 15 minutes' },
  { id: '1050', name: '17 hours 30 minutes' },
  { id: '1065', name: '17 hours 45 minutes' },
  { id: '1080', name: '18 hours' },
  { id: '1095', name: '18 hours 15 minutes' },
  { id: '1110', name: '18 hours 30 minutes' },
  { id: '1125', name: '18 hours 45 minutes' },
  { id: '1140', name: '19 hours' },
  { id: '1155', name: '19 hours 15 minutes' },
  { id: '1170', name: '19 hours 30 minutes' },
  { id: '1185', name: '19 hours 45 minutes' },
  { id: '1200', name: '20 hours' },
  { id: '1215', name: '20 hours 15 minutes' },
  { id: '1230', name: '20 hours 30 minutes' },
  { id: '1245', name: '20 hours 45 minutes' },
  { id: '1260', name: '21 hours' },
  { id: '1275', name: '21 hours 15 minutes' },
  { id: '1290', name: '21 hours 30 minutes' },
  { id: '1305', name: '21 hours 45 minutes' },
  { id: '1320', name: '22 hours' },
  { id: '1335', name: '22 hours 15 minutes' },
  { id: '1350', name: '22 hours 30 minutes' },
  { id: '1365', name: '22 hours 45 minutes' },
  { id: '1380', name: '23 hours' },
  { id: '1395', name: '23 hours 15 minutes' },
  { id: '1410', name: '23 hours 30 minutes' },
  { id: '1425', name: '23 hours 45 minutes' },
  { id: '1440', name: '24 hours' },
];

export const SLOT_TIME_WITHIN_RANGE = 'slotTimeWithinRange';

export const ACTIVITY_CTA_TYPES = [
  { name: 'Enquire', id: 'Enquire' },
  { name: 'Book', id: 'Book' },
];

export const ACTIVITY_CTA_CONTACT_OPTIONS = [
  { name: 'Email Id', id: 'email' },
  { name: 'Phone Number', id: 'phone' },
];

export const GENDER_OPTIONS = [
  { id: 'All', name: 'All' },
  { id: 'Male', name: 'Male' },
  { id: 'Female', name: 'Female' },
  { id: 'Other', name: 'Other' },
];

export const AUDIENCE_TYPE_OPTIONS = [
  { id: 'All', name: 'All' },
  { id: 'adultsOnly', name: 'Adults only' },
  { id: 'childOnly', name: 'Child only' },
];
